import { useLocation } from "react-router";
import { useClientPortalConfigContext } from "../context";

export function useClientPortalLocation(): string {
    const location = useLocation();
    const { clientPortalGuid } = useClientPortalConfigContext();
    const baseUrl = `/clientportal/${clientPortalGuid}/`;

    return location.pathname.replace(baseUrl, "");
}
